import { CPD_LOCALSTORAGE_KEY } from './constants';

export function clearCPDTimestamp() {
  if (window.localStorage) {
    window.localStorage.removeItem(CPD_LOCALSTORAGE_KEY);
  }
}
